// Usually I use this in my app's config file, in case I need to disable all cache from the app
// Cache is from `js-cache`, something like `import Cache from 'js-cache';`
import axios from "axios";

const instance = axios.create();

// On request, return the cached version, if any
instance.interceptors.request.use(
  (request) => {
    // Only cache GET requests and when cache flag is not false in req
    const cache = request.cache !== undefined ? request.cache : true;
    request.headers['X-Cache-Requested'] = cache;

    if (request.method === "get" && cache ) {
      let url = request.url;

      // Append the params (no jQuery needed)
      if (request.params) {
        url += "?" + new URLSearchParams(request.params).toString();
      }

      // Check if the response is cached in localStorage
      const cachedResponse = localStorage.getItem(url);
      let _cached = null;
      if (cachedResponse) {
        // Parse the cached response (assuming it was stringified before storing)
        if (cachedResponse.includes("data:application/octet-stream;base64")) {
          _cached = cachedResponse;
        } else {
          _cached = JSON.parse(cachedResponse);
          _cached.__fromCache = true;
        }

        console.log(`"${url}" served from cache:`, _cached);

        // Set the request data to the cached response
        request.data = _cached;

        // Set the request adapter to send the cached response
        request.adapter = () => {
          return Promise.resolve({
            data: _cached,
            status: 200, // You can set the status code here
            statusText: "OK",
            headers: request.headers,
            config: request,
            request: request,
          });
        };
      }
    }

    return request;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to cache the response after a successful GET request
instance.interceptors.response.use(
  (response) => {
    // Only cache successful GET requests
    console.log("axios response interceptor");
    const url = response.config.url;

    // Cache the response in localStorage
    // Only cache successful GET requests
    const isNoCacheRequest = response.config.headers['X-Cache-Requested'] === false;
    if (response.config.method === "get" && !isNoCacheRequest) {
      if (response.data instanceof Blob) {
        const fileReader = new FileReader();

        // Convert Blob to Base64
        fileReader.onloadend = () => {
          const base64Data = fileReader.result; // This is the Base64 string

          // Store the Base64 string in localStorage
          if (!localStorage.getItem(url)) {
            localStorage.setItem(url, base64Data);
          }

          // Optionally, log or manipulate the Base64 string
          console.log("File saved to localStorage:", base64Data);
        };

        // Handle errors in FileReader
        fileReader.onerror = () => {
          console.error("Error converting Blob to Base64");
        };

        // Read the Blob as Data URL (Base64)
        fileReader.readAsDataURL(response.data);
      } else {
        if (!localStorage.getItem(url)) {
          localStorage.setItem(url, JSON.stringify(response.data));
        }
      }
    }

    // Return the response so the request can continue as normal
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
